import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lightning, Gauge, Rocket } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

const WebsiteSpeedCta = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-blue-50 via-blue-50 to-blue-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="bg-white rounded-3xl p-12 shadow-xl border border-blue-100 max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-500 text-white rounded-2xl mb-6">
              <Lightning className="w-8 h-8" weight="thin" />
            </div>
            
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Klaar om je website te versnellen?
            </h3>
            
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
              We maken je website razendsnel zodat bezoekers blijven en je conversies stijgen. 
              Van analyse tot implementatie - we optimaliseren elke pixel voor snelheid.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/start-your-project" className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-blue-600 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <Rocket weight="thin" className="w-6 h-6" />
                Start je speed project
                <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" weight="thin" />
              </Link>
              
              <Link to="/start-your-project" className="inline-flex items-center justify-center gap-3 bg-white text-gray-700 px-8 py-4 rounded-full font-semibold text-lg border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all duration-300">
                <Gauge weight="thin" className="w-6 h-6" />
                Gratis speed test
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WebsiteSpeedCta;
